/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingMemoryForAwsPeriod extends models.BaseCostProcessingPeriodMemory {
    getFixupPrototypeFunction() { return CostProcessingMemoryForAwsPeriod.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingMemoryForAwsPeriod>): CostProcessingMemoryForAwsPeriod {
        let obj = Object.assign(new CostProcessingMemoryForAwsPeriod(), model);
        CostProcessingMemoryForAwsPeriod.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingMemoryForAwsPeriod>): CostProcessingMemoryForAwsPeriod {
        if (!model) return null;
        return CostProcessingMemoryForAwsPeriod.newInstance(<CostProcessingMemoryForAwsPeriod> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingMemoryForAwsPeriod) {
        if (!obj) return;

        models.CostProcessingMemoryForAwsPeriod.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingMemoryForAwsPeriod): boolean {
        if (models.BaseCostProcessingPeriodMemory.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingMemoryForAwsPeriod.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Fully processed reports
     */
    processed_reports: Array<string>;

    /**
     * Reports listed in the manifest but missing in the S3 bucket
     */
    missing_reports: Array<string>;

}
